<div class="login-page">
  <step-indicator
    [stepNumber]="1"
    ></step-indicator>
  <login-form></login-form>
</div>
